// NPM Import
import React from "react";

// Component Imports
import { ReactSelect } from "../../../commonComponents";

export default function ProductConfigurationSelect(props) {
  const { title, optionData, productValue, onSelectChange } = props;
  return (
    <div className="addproduct-div-wrapper">
      <span className="addproduct-label">
        {title}
        <span className="required-input">*</span>
      </span>
      <ReactSelect
        data-testid="addproduct-product-config-field"
        isSearchable
        valueKey="name"
        onChange={value => onSelectChange("productConfig", value)}
        options={optionData}
        value={productValue}
        data-test="productconfigurationselect-select"
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Products/ProductConfiguration/ProductConfigurationSelect.js